import { render, staticRenderFns } from "./LoadBetslip.vue?vue&type=template&id=767a6809&scoped=true"
import script from "./LoadBetslip.vue?vue&type=script&lang=js"
export * from "./LoadBetslip.vue?vue&type=script&lang=js"
import style0 from "./LoadBetslip.vue?vue&type=style&index=0&id=767a6809&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767a6809",
  null
  
)

export default component.exports